<script>
export default {
    name: 'FolderComponent',

    props: {
        folder: {
            type: Object,
            requiered: true
        },
        spacing: {
            type: Number,
            default: 0
        },
        selectedItem: {
            type: Number,
            default: -1
        }
    },

    emits: ['selected-folder', 'double-click', 'set-show-children'],

    data() {
        return {
            showChildren: false,
            clicks: 0,
            timer: null,
            delay: 300
        }
    },

    computed: {
        folderMargin() {
            return {
                'line-height': '16px',
                'margin-left': `${this.spacing}px`
            }
        },
        hasChildren() {
            const { children } = this.folder
            return children && children.length > 0
        }
    },

    watch: {
        selectedItem: function() {
            if (this.folder.id === this.selectedItem) {
                this.scrollElement('folder-' + this.folder.id)
            }
            if (this.searchTree(this.folder.children, this.selectedItem) != null) {
                this.showChildren = true
            }
        }
    },

    mounted() {
        if (this.folder.id === this.selectedItem) {
            this.scrollElement('folder-' + this.folder.id)
        }
        if (this.searchTree(this.folder.children, this.selectedItem) != null) {
            this.showChildren = true
        }
    },
    
    methods: {
        // Helper
        isElementInView(value) {
            const item = value.getBoundingClientRect(); 
            return ( 
                item.top >= 0 && 
                item.left >= 0 && 
                item.bottom <= ( 
                    window.innerHeight || 
                    document.documentElement.clientHeight) && 
                item.right <= ( 
                    window.innerWidth || 
                    document.documentElement.clientWidth) 
            )
        },
        scrollElement(name) { 
            const el = document.getElementById(name)
            if (!this.isElementInView(el)) {
                el.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
            }
        },
        
        searchTree(elements, id) {
            if (elements == null || elements.length === 0) {
                return null
            }

            for (let i = 0; i < elements.length; i++) {
                if (elements[i].id === id) {
                    return elements[i]
                }
                else {
                    let result = this.searchTree(elements[i].children, id)
                    if (result != null) {
                        return result
                    }
                }
            }
        },
        toggleChildren() {
            this.showChildren = !this.showChildren
        },
        setSelectedFolder(value) {
            this.clicks = 0
            
            this.showChildren = true
            this.$emit('selected-folder', value)
        },
        doubleClick(value) {
            this.showChildren = true           
            this.$emit('double-click', value)
        },
        handleClicks(value) {
            this.clicks++
            if (this.clicks === 1) {
                this.timer = setTimeout(this.setSelectedFolder, this.delay, value)
            }
            else {
                clearTimeout(this.timer)
                this.clicks = 0
                this.doubleClick(value)
            }
        }
    }
}
</script>


<template>
    <div class="selectable-div" :style="folderMargin">
        <div v-if="hasChildren" class="folder-chevron">
            <img v-if="!showChildren" src="@/assets/images/chevron-right.svg" @click="toggleChildren" />
            <img v-else src="@/assets/images/chevron-down.svg" @click="toggleChildren" />
        </div>
        <div v-else class="folder-chevron empty">&nbsp;</div>

        <div :id="'folder-' + folder.id" :class="'folder-name' + (selectedItem === folder.id ? ' selected' : '')" @click="handleClicks(folder.id)" :title="folder.name">{{ folder.name }}</div>

        <div v-if="hasChildren && showChildren">
            <FolderComponent v-for="child in folder.children" :key="child.id" :folder="child" :spacing="16" @selected-folder="setSelectedFolder" @double-click="doubleClick"
                :selected-item="selectedItem" />
        </div>
    </div>
</template>